import { FeatureOptionsSchema } from "@models/cusProductModels/cusProductModels";
import { DomesticPaymentProvider } from "@models/domesticPaymentModels/domesticPaymentModels";
import { z } from "zod/v4";
import { AttachDiscountSchema } from "../../api/billing/attachV2/attachDiscount";

export const ConfirmCheckoutParamsSchema = z
	.object({
		feature_quantities: z
			.array(
				FeatureOptionsSchema.pick({
					feature_id: true,
					quantity: true,
				}),
			)
			.optional(),
		discounts: z.array(AttachDiscountSchema).optional(),
		payment_provider: z
			.enum([DomesticPaymentProvider.WeChatPay, DomesticPaymentProvider.Alipay])
			.optional(),
		payment_method_type: z.enum(["wechatpay_native"]).optional(),
	})
	.refine(
		(value) => {
			if (!value.payment_provider && !value.payment_method_type) return true;
			return (
				value.payment_provider === DomesticPaymentProvider.WeChatPay &&
				value.payment_method_type === "wechatpay_native"
			);
		},
		{
			message:
				"payment_provider and payment_method_type must be a supported domestic payment pair",
		},
	);

export type ConfirmCheckoutParams = z.infer<typeof ConfirmCheckoutParamsSchema>;
